import React from 'react';
import { FiBookOpen, FiEdit, FiInfo, FiClock, FiX, FiUsers, FiTarget } from 'react-icons/fi';
import Button from '../common/Button';
import './ExamModeSelector.css';

const ExamModeSelector = ({ onModeSelect, onClose, testTitle, testDuration, questionCount }) => {
  return (
    <div className="exam-mode-selector-overlay">
      <div className="exam-mode-selector">
        <div className="selector-header">
          <div className="header-content">
            <h2>Choose Your Exam Mode</h2>
            <p>Select how you want to take this test</p>
          </div>
          <button className="close-button" onClick={onClose} aria-label="Close exam mode selector">
            <FiX />
          </button>
        </div>

        <div className="test-info">
          <h3>{testTitle}</h3>
          <div className="test-details-grid">
            <div className="detail-card">
              <div className="detail-icon-wrapper">
                <FiClock className="detail-icon" />
              </div>
              <div className="detail-content">
                <span className="detail-value">{testDuration && testDuration > 0 ? Math.max(Math.floor(testDuration / 60), 1) : 30}</span>
                <span className="detail-label">Minutes</span>
                <span className="detail-description">Recommended time limit</span>
              </div>
            </div>
            <div className="detail-card">
              <div className="detail-icon-wrapper">
                <FiEdit className="detail-icon" />
              </div>
              <div className="detail-content">
                <span className="detail-value">{questionCount || 0}</span>
                <span className="detail-label">Questions</span>
                <span className="detail-description">Total available questions</span>
              </div>
            </div>
            <div className="detail-card">
              <div className="detail-icon-wrapper">
                <FiTarget className="detail-icon" />
              </div>
              <div className="detail-content">
                <span className="detail-value">{testDuration && testDuration > 0 && questionCount > 0 ? Math.max(Math.round((testDuration / 60) / questionCount), 1) : 2}</span>
                <span className="detail-label">Min/Question</span>
                <span className="detail-description">Minutes per question</span>
              </div>
            </div>
            <div className="detail-card">
              <div className="detail-icon-wrapper">
                <FiUsers className="detail-icon" />
              </div>
              <div className="detail-content">
                <span className="detail-value">Practice</span>
                <span className="detail-label">Mode</span>
                <span className="detail-description">Unlimited attempts</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mode-options">
          <div className="mode-option">
            <div className="mode-header">
              <FiEdit className="mode-icon normal" />
              <h3>Normal Exam</h3>
            </div>
            <div className="mode-description">
              <p>Take the test like a traditional exam:</p>
              <ul>
                <li>Answer questions at your own pace</li>
                <li>Review and change answers before submitting</li>
                <li>See results and explanations after completion</li>
                <li>Navigate freely between questions</li>
              </ul>
            </div>
            <Button
              onClick={() => onModeSelect('normal')}
              variant="primary"
              size="large"
              className="mode-button"
            >
              Start Normal Exam
            </Button>
          </div>

          <div className="mode-option">
            <div className="mode-header">
              <FiBookOpen className="mode-icon explanation" />
              <h3>Explanation Exam</h3>
            </div>
            <div className="mode-description">
              <p>Learn as you go with immediate feedback:</p>
              <ul>
                <li>See explanations immediately after each answer</li>
                <li>Cannot change answers once selected</li>
                <li>Perfect for learning and understanding concepts</li>
                <li>Automatic progression to next question</li>
              </ul>
            </div>
            <Button
              onClick={() => onModeSelect('explanation')}
              variant="secondary"
              size="large"
              className="mode-button"
            >
              Start Explanation Exam
            </Button>
          </div>
        </div>

        <div className="selector-footer">
          <div className="info-note">
            <FiInfo className="info-icon" />
            <span>Your choice cannot be changed once the exam begins</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExamModeSelector;